<template>
  <div class="order-create__section">
    <div class="order-create__section-label section-label"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
                        'ex_packaging',
                        'ex_packagingMaxSize',
                      ])"></div>
      {{$t('ex_packaging.localization_value.value')}}
      <span class="capt" v-if="ex.express.type === DHL_DELIVERY_SERVICE.id">
          {{$t('ex_packagingMaxSize.localization_value.value')}}
        </span>
    </div>

<!--        :class="{'dhlPL-packing': isDHLPL}"-->
    <PackagingBlock
            :packaging="ex.express.packaging"
            :userId="parseInt(ex.express.userId)"
            :canUseScale="(_.has(currentPermissions, PERMISSIONS.USER_CAN_USE_SCALES) || isAdmin) && !isDHLPL"
            :allDisabled="ex.express.needPayFromFastReport"
            :captionDimensions="isDHLPL ? DHLPLCaptions : null"
        @changePackagingValue="changePackagingValue"
    />

    <template v-if="_.has(ex.express.user, 'id') && ex.getExpressType() === FEDEX_DELIVERY_SERVICE.id && checkFedexPackaging">
<!--      <div class="order-create__section-label section-label"-->
<!--           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">-->
<!--        <div class="admin-edit" @click="editTranslate(['express_fedexPacking'])"></div>-->
<!--        {{$t('express_fedexPacking.localization_value.value')}}-->
<!--      </div>-->

      <div class="order-create__product custom-row">
        <div class="order-create__product-col custom-col custom-col--50 custom-col--sm-100"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([
						FEDEX_PACKAGING_TYPES.HIMSELF_FEDEX_PACKAGING_TYPE.translate,
            FEDEX_PACKAGING_TYPES.FEDEX_PACKAGING_TYPE.translate,
            FEDEX_PACKAGING_TYPES.ENVELOPE_FEDEX_PACKAGING_TYPE.translate,
					])"></div>
          <DefaultSelect
              :options="fedexPacking"
              :label="$t('express_fedexPacking.localization_value.value')"
              :otherValue="'translation'"
              :selected="ex.express.fedexPackingType"
              :clearable="false"
              @change="changeFedexPackingType"
          />
        </div>
      </div>
    </template>

    <div class="order-create__row custom-row">
      <div class="order-create__row custom-col custom-col--33 custom-col--md-100  direction-column"
           v-if="(ex.getExpressType() !== NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.id && !isNPI) && (ex.express.type !== DHL_DELIVERY_SERVICE.id || (!isAdmin && (isUserAlternativeContactPoland || isPoland)) || isWarehousePyrzowice)"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
                        'express_INeedInsurance',
                        'express_InsurancePrice',
                      ])"></div>
        <DefaultCheckbox
                v-model="ex.express.packaging.packaging.insurance"
                :label="$t('express_INeedInsurance.localization_value.value')"
                @click="ex.express.packaging.packaging.insurance = !ex.express.packaging.packaging.insurance"
        />

        <DefaultInput
                class="mt-4 ml-4"
                :label="$t('express_InsurancePrice.localization_value.value')"
                v-bind:class="{
                  'ui-no-valid': ex.express.packaging.validation.insurancePrice,
                  required : ex.express.packaging.packaging.insurance
                }"
                :errorTxt="$t(`${ex.express.packaging.validationTranslate.insurancePrice}.localization_value.value`) +
                  ' ' + ex.express.packaging.validationTxt.insurancePriceMax"
                :error="ex.express.packaging.validation.insurancePrice"
                v-model="ex.express.packaging.packaging.insurancePrice"
                :disabled="!ex.express.packaging.packaging.insurance"
        />
      </div>
    </div>

    <div class="order-create__row custom-row">
      <div class="order-create__row custom-col custom-col--33 custom-col--md-100 d-flex align-items-end"
           v-if="isEdit && isAdmin"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
                          'express_TrackingNumber',
                        ])"></div>
        <DefaultInput
            class="w-100"
            :label="$t('express_TrackingNumberCDEKNP.localization_value.value')"
            v-model="ex.express.systemTrackingNumber"
        />
      </div>
    </div>

    <div
        v-if="isDHLPL"
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['express_findDHLPoint'])"></div>
      <a href="https://parcelshop.dhl.pl/mapa?type=fm&options_sending=with_label&hours_from=10&hours_to=16&week_days_PON=T&week_days_WT=T&week_days_SR=T&week_days_CZW=T&week_days_PT=T&week_days_SOB=N&week_days_NIEDZ=N&show_on_map_parcelshop=T&show_on_map_parcelshop_late=T&show_on_map_parcelstation=N&tab=sending"
        target="_blank"
         class="wfc d-flex"
      >
        <MainButton
            class="mb-3 wfc"
            :value="$t('express_findDHLPoint.localization_value.value')"
        />
      </a>

    </div>

  </div>
</template>

<script>
  import DefaultInput from '../../../../../../UI/inputs/DefaultInput/DefaultInput.vue'
  import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox.vue"
  import {mixinDetictingMobile} from "../../../../../../../mixins/mobileFunctions";
  import {expressMixinsFromCard} from "../../../../../../../mixins/expressMixins/expressMixin";
  import PackagingBlock from "../../../../../../coreComponents/PackagingBlock/PackagingBlock";
  import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
  import {
    FEDEX_DELIVERY_SERVICE,
    FEDEX_PACKAGING_TYPES,
    DHL_DELIVERY_SERVICE,
    NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE, MAX_DIMENSIONS_DHLPL
  } from "@/staticData/staticVariables";
  import MainButton from "@/components/UI/buttons/MainButton/MainButton";


  export default {
    name: "Packaging",
    components: {
      MainButton,
      DefaultSelect,
      PackagingBlock,
      DefaultInput,
      DefaultCheckbox,
    },

    mixins: [mixinDetictingMobile, expressMixinsFromCard],

    props: {
      ex: Object,
      serverError: {
        type: Boolean,
        default: false,
      },
      hideAddProfile: {
        type: Boolean,
        default: false
      },
      isEdit: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        options: [{}],

        DHLPLCaptions: {
          cWidth: '(max. 41cm)',
          cLength: '(max. 64cm)',
          cHeight: '(max. 38cm)',
          cWeight: '(max. 25 kg)',
        },

        fedexPacking: [
          {
            // name: this.$t(`${FEDEX_PACKAGING_TYPES.HIMSELF_FEDEX_PACKAGING_TYPE.translate}.localization_value.value`),
            translation: FEDEX_PACKAGING_TYPES.HIMSELF_FEDEX_PACKAGING_TYPE.translate,
            value: FEDEX_PACKAGING_TYPES.HIMSELF_FEDEX_PACKAGING_TYPE.value
          },
          {
            // name: this.$t(`${FEDEX_PACKAGING_TYPES.FEDEX_PACKAGING_TYPE.translate}.localization_value.value`),
            translation: FEDEX_PACKAGING_TYPES.FEDEX_PACKAGING_TYPE.translate,
            value: FEDEX_PACKAGING_TYPES.FEDEX_PACKAGING_TYPE.value
          },
          {
            // name: this.$t(`${FEDEX_PACKAGING_TYPES.ENVELOPE_FEDEX_PACKAGING_TYPE.translate}.localization_value.value`),
            translation: FEDEX_PACKAGING_TYPES.ENVELOPE_FEDEX_PACKAGING_TYPE.translate,
            value: FEDEX_PACKAGING_TYPES.ENVELOPE_FEDEX_PACKAGING_TYPE.value
          },
        ],

        FEDEX_PACKAGING_TYPES: FEDEX_PACKAGING_TYPES,
        FEDEX_DELIVERY_SERVICE: FEDEX_DELIVERY_SERVICE,
        DHL_DELIVERY_SERVICE: DHL_DELIVERY_SERVICE,
        NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE: NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE,
      }
    },

    computed: {
      user: function () {
        return this.ex.express.userId
      },
    },

    // watch: {
    // user: function() {
    //   this.getExpressProformPackaging()
    // },
    //
    // loadUserAuthorizedData: function() {
    //   this.getExpressProformPackaging()
    // },
    // },

    mounted() {
      if(!this.isEdit && this.ex.express.fedexPackingType === '') {
        this.ex.express.fedexPackingType = this._.first(this.fedexPacking)
      }
    },

    methods: {
      changeFedexPackingType(val) {
        this.ex.setFedexPackingType(val)
      },

      changePackagingValue(type) {
        if(this.isDHLPL) {
          this.ex.express.packaging.packagingPartialValidate({
            weight: type === 'weight',
            height: type === 'height',
            width: type === 'width',
            packageLength: type === 'length',
            maxDimensions: MAX_DIMENSIONS_DHLPL
          })
        }
      }
    },

  }
</script>

<style scoped>
.capt {
  font-size: 14px;
  line-height: 23px;
  font-weight: 400;
  margin-left: 10px;
}

/*.express-packing >>> .order-create__row .order-create__col:nth-child(1) {*/
/*  order: 1;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(2) {*/
/*  order: 2;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(3) {*/
/*  order: 3;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(4) {*/
/*  order: 6;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(5) {*/
/*  order: 5;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(6) {*/
/*  order: 4;*/
/*}*/

/*.express-packing >>> .order-create__row .order-create__col:nth-child(7) {*/
/*  order: 7;*/
/*}*/
</style>
